import React from 'react';
import {
  Container, Col, Row, Div,
} from '../../components/grid';
import {
  Heading1,
  Span,
  Paragraph,
  LinkStyled,
  Heading2,
  List,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';
import { Image } from '../../components/Image';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Modular20">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Modular 20 fustager</Heading1>
        </Col>
        <Col xs={12}>
          <Paragraph>
            Hos Skafte fører vi et udvalgt sortiment af Modular 20 fadølsfustager. OBS: Kræver eget Modular 20 anlæg. Vi udlejer ikke udstyr til disse typer fustager. Modular 20 fustager lagerføres ikke, men tages hjem på bestilling mod forudbetaling. Ingen returret.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelModular20" display={ProductView1} filterLiterSize />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Carlsberg Modular 20 plastikfustager</Heading2>
          <Paragraph>
            Mellem 2016 og 2023 har Carlsberg løbende udskiftet deres stålfustager til 20-liters Modular 20 plastikfustager, hvilket nu er en af de foretrukne fustagetyper i restaurationsbranchen.
          </Paragraph>
          <Paragraph>
            Systemet med de “nye” plastikfustager kaldes Draughtmaster Modular 20 og Carlsberg sælger alle deres egne varemærker, samt en del importerede varianter i disse fustager. Modular 20 er den mest populære version af plastikfustager, men hos Skafte finder du også den beslægtede variant, <LinkStyled to="/fadoel/flex-20">Flex 20</LinkStyled>, hvor systemet har en medfølgende tappeslange. Vi udlejer desværre ikke fadølsanlæg til Modular 20.
          </Paragraph>
          <Paragraph>
            Vær opmærksom på, at Modular 20 kræver specielt udstyr til tapning. Både køleanlæg og tappehaner kan bruges som de er, men der skal anvendes en tryktank og en kompressor for at få øllet ud af fustagen.
            Grundet trykket og Modular 20’s materiale, vil plastikfustagen være helt fladmast, når øllet er skænket. Plastikken kan returneres til Carlsberg, hvor den genanvender plasten.
          </Paragraph>
          <Paragraph>
            Den største fordel ved Modular 20 er holdbarheden. Efter anbrud af fustagen kan øllet nemlig holde sig helt op til 30 dage. Yderligere er den lave vægt en fordel; øllet leveres i 20 liters plastikfustager stående i en papkarton, hvor den samlede vægt kun er 21.2 kg, hvor øllet heraf vejer 20 kg.
          </Paragraph>
        </Col>
        <Col xs={12}>
          <Div textCenter marginBottom="20px">
            <Image imageHeight="300px" name="fadoel.modular-20-rullebar.jpg" alt="Modular 20 rullebar" /><br />
            <Span fontSize="12px">Modular 20 system med rensemodul, 4 tryktanke og køleanlæg i rullebar, hvor låget er taget tryktank nr. 3. Det grønne på billedet er Modular 20 fustagen på hovedet, sat ned i tryktanken.</Span>
          </Div>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Ved bestilling af Modular 20 fustager</Heading2>
          <Paragraph>
            Vi gør opmærksom på, at der kræves et særligt fadølsanlæg, der passer til Draughtmaster Modular 20 fustager. Skafte udlejer ikke denne type fadølsanlæg.
          </Paragraph>
          <Paragraph>
            Der er pant på Modular 20 fustager: 40 kr + moms = pant på 50 kr.
          </Paragraph>
          <Paragraph>
            Vi lagerfører ikke Modular 20 plastikfustager, men får dem fra vores fjernlager. Du må derfor forvente en smule forlænget ventetid. Vi anbefaler, at du bestiller dine plastikfustager med fadøl mindst 5 dage inden brug.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Hvilken fadøl skal du have på Modular 20 fustage?</Heading2>
          <Paragraph>
            Hos Skafte fører vi et skønt udvalg af fadøl på Modular 20 fustager, der gør det let at servere favoritøllen til gæsterne.
          </Paragraph>
          <Paragraph>
            Blandt vores udvalg finder du bl.a.:
          </Paragraph>
          <List>
            <li>Tuborg Guld</li>
            <li>Tuborg Classic</li>
            <li>Grøn Tuborg</li>
            <li>Brooklyn Lager</li>
            <li>Carlsberg Pilsner</li>
            <li>Grimbergen Double Ambrée</li>
            <li>Grimbergen Blonde</li>
            <li>Jacobsen Brown Ale</li>
            <li>Jacobsen Yakima IPA</li>
            <li>Carlsberg Nordic Ale (alkoholfri)</li>
            <li>Jacobsen Christmas Ale</li>
            <li>Tuborg Påskebryg</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Hvordan fungerer Modular 20?</Heading2>
          <Paragraph>
            På restauranter, caféer, barer og andre udskænkningssteder monteres normalt en række tryktanke ved siden af hinanden, derudover monteres et halvautomatisk rensemodul.
          </Paragraph>
          <Paragraph>
            Princippet er, at Modular 20 ølfustagen puttes ned i en beholder, og at der pumpes trykluft i mellemrummet mellem plastikfustage og beholdervæggen. På denne måde trykkes øllet ud af fustagen og via en slange frem til ølkøleren, herefter er fadølsinstallationen helt normal. Når fustagen er tom, åbnes trykbeholderen (først &quot;piftes&quot; den) og den nu helt sammentrykkede plastikfustage tages ud og erstattes med en ny.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Image maxHeight="200px" imageHeight="200px" name="fadoel.draughtmaster-stor-model.jpg" alt="DraufhtMaster Køleskab og tappehane til  20l kegs" /><br />
          <Span fontSize="12px">Ovenstående er et 20 l Draughtmaster Flex køleanlæg. Vi udlejer ikke denne model.</Span>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
